<template>
  <el-form ref="advertising-format" :model="form" :rules="rules" label-width="120px">
    <el-form-item prop="adFormat" style="margin-bottom: 0">
      <template #label>
        着陆页 <gj-help>顾客在与您的广告互动后将被引导至着陆页。</gj-help>
      </template>
      <div>
        <el-radio v-model="form.adFormatUrl" :label="0" :disabled="!addBase.brandEntityId">品牌旗舰店店铺</el-radio>
        <span class="msg">（在亚马逊卖家后台品牌旗舰店-关联店铺下创建）</span>
      </div>
      <gj-select v-if="noBrand" v-model="addBase.brandEntityId" width="180px" placeholder="品牌" disabled :options="cOptions.brandEntity"></gj-select>
      <gj-select v-model="form.landingPage.url" width="180px" placeholder="店铺页面" :loading="cOptions.loading.shopOptions" :options="cOptions.shopOptions" :disabled="!addBase.brandEntityId"></gj-select>
      <div style="margin-bottom: 6px;">
        <el-radio v-model="form.adFormatUrl" :label="1">创建商品列表页</el-radio>
        <span class="msg">（着陆页上必须始终有至少 1 种商品可供购买，否则广告活动将被暂停）</span>
      </div>
      <ProductPicker 
        v-if="form.adFormatUrl == 1"
        :group-id="form.baseInfoForm"
        group-required
        :marketId="publicObj.SB.marketId"
        :form="form.landingPage"
        title="商品"/>
    </el-form-item>
  </el-form>
</template>

<script>
import ProductPicker from "../../../common/modal/add/common/product-picker"
import { getLandingPage } from "@/api/ad"
export default {
  components: { ProductPicker },
  inject: ["getForms", "getOptions", 'getPublicObj'],
  props: {
    noBrand: {
      default: true
    }
  },
  data() {
    return {
      shopLoading: false, // 加载店铺页面的loading
      addBase: {},
      creative: {},
      form: {},
      rules: {
          adFormat: [
            { required: true, message: '请选择着陆页', trigger: ['blur', 'change'] }
          ]
      }
    }
  },
  computed: {
    publicObj() {
      return this.getPublicObj()
    },
    cOptions() {
      return this.getOptions() || {
        loading: {
          shopOptions: false
        },
        brandEntity: [],
        shopOptions: []
      }
    }
  },
  methods: {},
  created() {
    let { addBase, addAdvertisingFormat, creative } = this.getForms()
    this.addBase = addBase
    this.creative = creative
    this.form = addAdvertisingFormat
  }
};
</script>

<style scoped lang="scss">
/deep/.gj-select {
  padding: 6px 16px 6px 0;
}
.msg {
  display: inline-block;
  color: #969696;
  font-size: 12px;
  transform:  translateX(-30px);
}
</style>